import { useQuery } from 'react-query';
import { api } from 'src/api/axios';

export const useListPart = (keyword: string, page: number, size: number) =>
  useQuery(['listPart', keyword, page, size], async () => {
    const res = await api.get('/api/cms/part', {
      params: {
        keyword: keyword,
        page: page,
        size: size,
      },
    });
    return res.data.data;
  });
